import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Separate axios instance for the vendor portal.
// Uses its own localStorage token so it never clashes with the
// admin/staff session (which lives under "adams_token").
export const vendorApi = axios.create({ baseURL: API });

vendorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("adams_vendor_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

vendorApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("adams_vendor_token");
      const path = window.location.pathname;
      if (path.startsWith("/vendor") && !path.startsWith("/vendor/login")) {
        window.location.href = "/vendor/login";
      }
    }
    return Promise.reject(err);
  }
);
